import { Menu } from '~/donation/types/menu.types'
import ROUTES from '~/shared/constants/routes.const'

export const menus: Menu[] = [
  { titleKey: 'home', path: ROUTES.MATHMAGIC },
  { titleKey: 'media', path: ROUTES.MATHMAGIC_MEDIA },
  { titleKey: 'esg', path: ROUTES.MATHMAGIC_ESG },
  { titleKey: 'sponsors', path: ROUTES.MATHMAGIC_SPONSORS },
]
